import { render, staticRenderFns } from "./receiptReports.vue?vue&type=template&id=2e56722c"
import script from "./receiptReports.vue?vue&type=script&lang=js"
export * from "./receiptReports.vue?vue&type=script&lang=js"
import style0 from "./receiptReports.vue?vue&type=style&index=0&id=2e56722c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports